var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OrderValidation } from './../orderValidation';
import { CurrentOrderService } from './../currentOrder.service';
import { Observable } from 'rxjs/Rx';
import { OrderService } from './../order.service';
import { FlagService } from './../../modules/features/flag.service';
import { AlgoliaSearchComponent } from './../../modules/algolia/algolia-search/algolia-search.component';
import { Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Item } from '../order';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Config } from '../../config/config';
import { MixpanelService } from '../../mixpanel/mixpanel.service';
var $ = require('jquery');
global.jQuery = $;
require('metismenu');
var OrderPartComponent = (function () {
    function OrderPartComponent(titleService, route, translate, flag, orderService, currentOrderService, orderValidation, mixpanelService) {
        var _this = this;
        this.titleService = titleService;
        this.route = route;
        this.translate = translate;
        this.flag = flag;
        this.orderService = orderService;
        this.currentOrderService = currentOrderService;
        this.orderValidation = orderValidation;
        this.mixpanelService = mixpanelService;
        this.nbrResults = 0;
        this.algoliaIndex = Config.getEnvironmentVariable("algoliaIndex");
        this.currentOrderService.orderType.subscribe(function (orderType) { return _this.orderType = orderType; });
        this.currentOrderService.order.subscribe(function (order) { return _this.order = order; });
        if (this.orderType.lowercaseType == "order") {
            var title1_1;
            translate.get('ORDER.ORDER_TITLE').subscribe(function (value) { return title1_1 = value; });
            translate.get('ORDER.MAIN_COMPONENT.TITLE').subscribe(function (value) { return _this.titleService.setTitle(title1_1 + ' ' + value + ' | Uptime'); });
        }
        else {
            translate.get('ORDER.QUOTE_REQUEST_UPPERCASE').subscribe(function (value) { return _this.titleService.setTitle(value + ' | Uptime'); });
        }
        this.mixpanelService.trackEvent("new " + this.orderType.lowercaseType, null);
    }
    OrderPartComponent.prototype.ngOnInit = function () {
        this.currentOrderService.setMenuVisibility({
            part: true,
            address: false,
            billing: false,
            shipping: false,
            summary: false,
            completed: false
        });
        this.brands = this.route.snapshot.data['brands'];
        this.brands = this.brands.sort(function (b1, b2) { return b1.Order - b2.Order; });
        this.isAlgoliaSearchActive = this.flag.isAlgoleaSearchActive();
        this.isItemBrandActive = this.flag.isItemBrandActive();
        //commented out, if we need to rollback from AlgoliaSearch, we will have to patch the new Item() for mandrill who can't iterate properly
        // if(!this.isAlgoliaSearchActive && this.order.Items.length<1){
        //   this.order.Items.push(new Item());
        // }
        this.uploadingFile = [];
        this.windowResize();
    };
    OrderPartComponent.prototype.windowResize = function () {
        if ($(document).width() < 961) {
            $('body').addClass('body-small');
        }
        else {
            $('body').removeClass('body-small');
            $('body').removeClass('mini-navbar');
        }
    };
    OrderPartComponent.prototype.changeBrand = function (brandId) {
        this.order.Brand = this.brands.find(function (brand) { return brand.Id == brandId; });
    };
    OrderPartComponent.prototype.removeItem = function (item) {
        var index = this.order.Items.indexOf(item, 0);
        if (index > -1) {
            this.order.Items.splice(index, 1);
            this.uploadingFile.splice(index, 1);
        }
    };
    OrderPartComponent.prototype.getItemsFieldsClass = function () {
        return this.orderValidation.getItemsFieldsClass();
    };
    OrderPartComponent.prototype.checkField = function (event) {
        if (event.target.name == 'brand' && event.target.value != '')
            this.order.Brand = this.brands.find(function (brand) { return brand.Id == event.target.value.substr(event.target.value.indexOf(': ') + 2); });
        if (event.target.parentElement.className.match(/(?:^|\s)has-error(?!\S)/))
            event.target.parentElement.className = event.target.parentElement.className.replace(/(?:^|\s)has-error(?!\S)/g, '');
        if (event.target.value == '') {
            event.target.parentElement.className += " has-error";
        }
    };
    OrderPartComponent.prototype.isValid = function () {
        return this.orderValidation.isPartValid();
    };
    OrderPartComponent.prototype.resetForm = function () {
        this.order.Items = [];
        this.uploadingFile = [];
        this.order.Brand = {
            Id: "",
            Name: "",
            Order: 0
        };
    };
    OrderPartComponent.prototype.getDrawingNumber = function (result) {
        if (result.DrawingNum) {
            if (result.ThirdItemNum) {
                return result.DrawingNum + " / " + result.ThirdItemNum;
            }
            else {
                return result.DrawingNum;
            }
        }
        else {
            if (result.ThirdItemNum) {
                return (result.ThirdItemNum);
            }
            else {
                return null;
            }
        }
    };
    OrderPartComponent.prototype.addPart = function (result) {
        var item = new Item();
        item.Description = result.Desc1;
        item.Qty = 1;
        item.PartNumber = result.PartNum;
        item.DrawingNum = this.getDrawingNumber(result);
        item.Uom = result.UOM;
        item.isDuplicate = result.partNum_exists == 1 ? true : false;
        item.brand = result.Brand;
        //item.sourceSystem = result.SourceSystem;
        item.file = null;
        item.fileKey = null;
        item.fileName = null;
        item.fileURL = null;
        item.ThirdItemNum = result.ThirdItemNum;
        this.order.Items.push(item);
        this.uploadingFile.push(false);
        this.search.track('Item added', result.index * 1 + 1);
        this.search.reset();
    };
    OrderPartComponent.prototype.createPart = function (num, desc) {
        var item = new Item();
        item.Description = desc;
        item.Qty = 1;
        item.PartNumber = num;
        item.DrawingNum = "";
        item.Uom = "";
        item.file = null;
        item.fileKey = null;
        item.fileName = null;
        item.fileURL = null;
        item.ThirdItemNum = "";
        this.order.Items.push(item);
        this.uploadingFile.push(false);
        this.search.track('Custom item added', 0);
        this.search.reset();
    };
    OrderPartComponent.prototype.addItem = function () {
        var item = new Item();
        item.Description = "";
        item.PartNumber = "";
        item.DrawingNum = "";
        item.Uom = "";
        item.file = null;
        item.fileKey = null;
        item.fileName = null;
        item.fileURL = null;
        item.ThirdItemNum = "";
        this.order.Items.push(item);
        this.uploadingFile.push(false);
    };
    OrderPartComponent.prototype.attachFile = function (event, item, index) {
        var _this = this;
        if (this.flag.isFileItemActive()) {
            this.uploadingFile[index] = true;
            var fileList = event.target.files;
            if (fileList.length > 0) {
                var file_1 = fileList[0];
                this.orderService.uploadFile(file_1)
                    .then(function (result) {
                    item.fileKey = result.key;
                    item.fileURL = result.url + '/' + result.key;
                    item.fileName = file_1.name;
                    item.file = null;
                    _this.uploadingFile[index] = false;
                    console.log('upload succedded ' + result);
                })
                    .catch(function (error) {
                    console.log('Error uploading file : ' + error);
                    if (error != "file type not allowed")
                        error = "An error occured while submitting your file. Please try again.";
                    item.file = null;
                    _this.uploadingFile[index] = false;
                    var title = _this.translate.get('Error');
                    var text = _this.translate.get(error);
                    Observable.forkJoin(title, text).subscribe(function (res) {
                        swal({
                            title: res[0],
                            text: res[1],
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonText: 'OK'
                        });
                    });
                });
            }
        }
    };
    __decorate([
        ViewChild(AlgoliaSearchComponent),
        __metadata("design:type", Object)
    ], OrderPartComponent.prototype, "search", void 0);
    OrderPartComponent = __decorate([
        Component({
            selector: 'cx-orderpart',
            templateUrl: './orderpart.component.html',
        }),
        __metadata("design:paramtypes", [Title,
            ActivatedRoute,
            TranslateService,
            FlagService,
            OrderService,
            CurrentOrderService,
            OrderValidation,
            MixpanelService])
    ], OrderPartComponent);
    return OrderPartComponent;
}());
export { OrderPartComponent };
//# sourceMappingURL=orderpart.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/wizard/orderpart.component.js
// module id = 189
// module chunks = 0